<!--
 * @Author: Merlin
 * @Date: 2024-04-01 10:16:04
 * @LastEditors: Merlin
 * @LastEditTime: 2025-01-08 17:02:06
 * @Description: 
-->
<template>
    <div></div>
</template>

<script lang="ts">
import {jump2TargetCoin} from '@/pages/casino/futuresGame/ts/wavesFn';

export default defineComponent({ 
    name: 'futuresGamePortal',
    created(){
        if (
            import.meta.client
            && !new URLSearchParams(window.location.search).get('au') 
        ) {
            // ↓ 重定向（同原版，这里必须要指明币种）
            console.log('waves 游戏已经重定向'); 
            jump2TargetCoin();
        }
    },
});

</script>


<style scoped lang="scss"> 

</style>


